import {ComponentAsElement} from '../../../services/common/bootstrap/annotation/component-as-element';
import {Component} from '@angular/core';
import {CommonModalBase} from '../common/commonModalBase.abstract';
import {CommonModalTemplatesEnum} from '../all-modals-config';
import {CommonModalService} from '../../common-modal/common-modal.service';
import {ModalInformationAndActionDataInterface} from "./modal-information-and-action-data.interface";


@ComponentAsElement('v-modal-information-and-action-element')
@Component({
  selector: 'v-modal-information-and-action',
  templateUrl: './modal-information-and-action.html',
  styleUrls: []
})
export class ModalInformationAndActionComponent extends CommonModalBase<ModalInformationAndActionDataInterface> {
  constructor(
    commonModalService: CommonModalService
  ) {
    super(
      commonModalService,
      CommonModalTemplatesEnum.INFO_ADN_ACTION
    );
  }

  submitFunc(event: MouseEvent): void {
    if (this.modalData && typeof this.modalData.submitBtn === 'function') {
      this.modalData.submitBtn(event)
    }
  }

  hideFunc(event: MouseEvent): void {
    if (this.modalData && typeof this.modalData.hidePopupBtn === 'function') {
      this.modalData.hidePopupBtn(event)
    }
  }
}
